import _ from 'lodash';
import { emailRe, emailPatsnap, patsnapOrZhihuiya } from '@/utils/regex';
import isValidDomain from 'is-valid-domain';
export function isEmail(s) {
    return emailRe.test(s);
}
export function isEmailPatsnap(s) {
    return emailPatsnap.test(s);
}
export function isPatsnapOrZhihuiya(s) {
    return patsnapOrZhihuiya.test(s);
}
// 域名校验
export function isDomain(s) {
    return isValidDomain(s) && _.size(s) <= 32;
}
/**
 * 仅仅是中国区的手机号校验
 */
export function isPhoneNumber(s) {
    // 反向测试没有非数字的
    return !(/\D/.test(s)) && _.size(s) === 11;
}
export function isName(val) {
    val = _.trim(val);
    const length = _.size(val);
    if (length === 0) {
        return true;
    }
    // 1. 特殊字符检查
    const hasError = /@/.test(val);
    // 2.是不是都是数字
    const match = val.match(/[0-9]+/);
    let allNumber = false;
    if (match && match.length === 1) {
        if (match[0] === val) {
            allNumber = true;
        }
    }
    if (hasError || allNumber) {
        return false;
    }
    return true;
}
export function isStartWithLocalAreaNetwork(val) {
    const splitReg = / |,|;|\n|\t|，|；|、|\|\|/;
    const valAry = val.split(splitReg);
    const findErr = _.find(valAry, i => {
        return _.startsWith(i, '192.168');
    });
    if (findErr) {
        return true;
    }
}
export function isSingleIPStartWithLocalAreaNetwork(val) {
    const findErr = _.startsWith(val, '192.168');
    if (findErr) {
        return true;
    }
}
/**
 * 文件大小校验
 * 单位为kb 和 mb
 */
export function fileSizeValidator(file, size, unit = 'kb') {
    const fileSize = file.size;
    if (unit === 'kb') {
        return fileSize <= size * 1024;
    }
    else if (unit === 'mb') {
        return fileSize <= size * 1024 * 1024;
    }
}
